import QueryResult from '@/common/network/QueryResult';
import { ConstantsResponse } from '@/common/types/constantsResponse';
import { ViewerPresetsResponse } from '@/hpo/types/viewerPreset';

import CutwiseAPIClient, { METHOD_GET } from '../network/CutwiseAPIClient';

export const PATH_CONSTANTS = 'api/v2/constants/web';
export const PATH_VIEWER_PRESETS = 'api/v2/constants/cv';

export default class ConstantsAPI {
  fetchAll(): Promise<QueryResult<ConstantsResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_CONSTANTS).isAnon();

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }

  fetchViewerPresets(): Promise<QueryResult<ViewerPresetsResponse>> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_GET).path(PATH_VIEWER_PRESETS);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}
